import {
  Box,
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuList,
} from "@chakra-ui/react";
import { ExportMlggkProjectsEffectivenessButton } from "@components/modules/projects/list/components/navbar/components/export-mlggk-projects-effectiveness-button";
import { ExportProjectsEffectivenessButton } from "@components/modules/projects/list/components/navbar/components/export-projects-effectiveness-button";
import { ExportTriadProjectsEffectivenessButton } from "@components/modules/projects/list/components/navbar/components/export-triad-projects-effectiveness-button";
import { ExportButton, NavBar } from "@components/ui-kit";
import { Icon } from "@components/ui-kit/Icon";
import { Trans } from "@lingui/macro";
import type { Brand } from "@src/__generated__/urql-graphql";
import { Can } from "@src/utils/components/permissions";
import { useStore as useAppStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { CreateProjectMenu } from "../../../create/project-menu";
import { QuickFilter, useStore } from "../../Store";
import { ProjectListNavbarStore } from "./store";

interface ProjectListNavBarProps {
  brandId?: Brand["id"];
}

const ProjectListNavBar = ({ brandId }: ProjectListNavBarProps) => {
  const { pipedriveStore } = useAppStore();
  const projectsStore = useStore();
  const [store] = useState(() => new ProjectListNavbarStore(projectsStore));

  useEffect(() => {
    pipedriveStore.fetchOptions();
  }, []);

  return (
    <HStack justifyContent="space-between">
      <NavBar>
        <NavBar.Item
          active={projectsStore.quickFilter.value[0] === QuickFilter.Pinned}
          onClick={() => projectsStore.handleChangeTab(QuickFilter.Pinned)}
        >
          <Trans>Pinned</Trans>
        </NavBar.Item>
        <NavBar.Item
          active={projectsStore.quickFilter.value[0] === QuickFilter.Starred}
          onClick={() => projectsStore.handleChangeTab(QuickFilter.Starred)}
        >
          <Trans>Starred</Trans>
        </NavBar.Item>
        <NavBar.Item
          active={
            !projectsStore.quickFilter.value.length &&
            !projectsStore.pipedriveStageFilter?.value.length
          }
          onClick={() => {
            projectsStore.quickFilter.clear();
            projectsStore.pipedriveStageFilter?.clear();
          }}
        >
          <Trans>All</Trans>
        </NavBar.Item>

        <NavBar.Item
          active={projectsStore.quickFilter.value[0] === QuickFilter.Active}
          onClick={() => projectsStore.handleChangeTab(QuickFilter.Active)}
        >
          <Trans>All Active</Trans>
        </NavBar.Item>

        <NavBar.Item
          active={projectsStore.quickFilter.value[0] === QuickFilter.MyActive}
          onClick={() => projectsStore.handleChangeTab(QuickFilter.MyActive)}
        >
          <Trans>My Active</Trans>
        </NavBar.Item>

        <NavBar.Item
          active={projectsStore.quickFilter.value[0] === QuickFilter.Finished}
          onClick={() => projectsStore.handleChangeTab(QuickFilter.Finished)}
        >
          <Trans>Finished</Trans>
        </NavBar.Item>

        <NavBar.Item
          active={projectsStore.quickFilter.value[0] === QuickFilter.Archived}
          onClick={() => projectsStore.handleChangeTab(QuickFilter.Archived)}
        >
          <Trans>Archived</Trans>
        </NavBar.Item>
        {pipedriveStore.projectStageOptions.map((stage) => (
          <NavBar.Item
            key={`project-stage-navbar-item-${stage.value}`}
            active={
              projectsStore.pipedriveStageFilter?.value[0] === stage.value
            }
            onClick={() => {
              projectsStore.quickFilter.clear();
              projectsStore.pipedriveStageFilter?.setValue(stage.value);
            }}
          >
            {stage.label}
          </NavBar.Item>
        ))}
      </NavBar>

      <HStack spacing="2">
        <Box>
          <Menu>
            <MenuButton
              as={ExportButton}
              isLoading={store.isExporting}
              rightIcon={<Icon name="chevron-down" />}
            />
            <MenuList>
              <ExportProjectsEffectivenessButton store={store} />
              <ExportMlggkProjectsEffectivenessButton store={store} />
              <ExportTriadProjectsEffectivenessButton store={store} />
            </MenuList>
          </Menu>
        </Box>
        <Can
          do={[
            "project_create_all",
            "project_create_team",
            "project_create_own",
          ]}
        >
          <CreateProjectMenu
            queryParams={brandId ? { brand_id: brandId } : undefined}
          >
            <Button leftIcon={<Icon name="plus" />}>
              <Trans>New Project</Trans>
            </Button>
          </CreateProjectMenu>
        </Can>
      </HStack>
    </HStack>
  );
};

export default observer(ProjectListNavBar);
